import { render, staticRenderFns } from "./ContactosClientes.vue?vue&type=template&id=708a4350&scoped=true"
import script from "./ContactosClientes.vue?vue&type=script&lang=js"
export * from "./ContactosClientes.vue?vue&type=script&lang=js"
import style0 from "./ContactosClientes.vue?vue&type=style&index=0&id=708a4350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a4350",
  null
  
)

export default component.exports